import LOOKUP_TYPES, {
  KPI_ACTIONS,
} from '../../common/constants/SuccessPlanConstants';
import responseFormatter from '../../common/util/ResponseFormatter';
import {
  fetchKPIProgressLookupsV2,
  fetchKPIsV2,
  fetchKPIByIdV2,
  createKPIV2,
  editKPIV2,
  resetKPIsV2,
  archiveKPIV2,
} from '../routines/successPlanRoutines';

const { KPI_PROGRESS } = LOOKUP_TYPES;
const initialState = {
  [KPI_PROGRESS]: {
    data: [],
    dataMap: {},
    loading: false,
    error: null,
  },
  kpiList: {
    data: [],
    loading: true,
    error: null,
  },
  kpi: {
    data: null,
    loading: false,
    error: null,
  },
  kpiProgress: {
    data: null,
    loading: false,
    error: null,
    showModal: false,
    action: KPI_ACTIONS.EDIT,
  },
  actionLoading: false,
  kpiModal: {
    loading: false,
  },
};

const successPlanKPIReducerV2 = (state = initialState, action) => {
  switch (action.type) {
    case fetchKPIsV2.TRIGGER:
      return {
        ...state,
        kpiList: { ...state.kpiList, loading: true },
      };
    case fetchKPIsV2.SUCCESS:
      return {
        ...state,
        kpiList: {
          ...state.kpiList,
          data: action.payload,
          loading: false,
          error: null,
        },
      };
    case fetchKPIsV2.FAILURE:
      return {
        ...state,
        kpiList: {
          ...state.kpiList,
          loading: false,
        },
      };
    case fetchKPIsV2.FULFILL:
      return {
        ...state,
        kpiList: {
          ...state.kpiList,
          loading: false,
        },
        kpiModal: {
          loading: false,
        },
      };
    case archiveKPIV2.TRIGGER:
      return {
        ...state,
        kpiModal: {
          loading: true,
        },
      };
    case archiveKPIV2.FAILURE:
      return {
        ...state,
        kpiModal: {
          archiveComplete: false,
        },
      };
    case createKPIV2.TRIGGER:
    case editKPIV2.TRIGGER:
      return {
        ...state,
        actionLoading: true,
      };
    case createKPIV2.SUCCESS:
    case editKPIV2.SUCCESS:
    case createKPIV2.FAILURE:
    case editKPIV2.FAILURE:
      return {
        ...state,
        actionLoading: false,
      };

    case fetchKPIByIdV2.TRIGGER:
      return {
        ...state,
        kpi: { ...state.kpi, data: null, loading: true },
      };
    case fetchKPIByIdV2.SUCCESS:
      return {
        ...state,
        kpi: {
          ...state.kpi,
          loading: false,
          data: action.payload,
        },
        kpiProgress: { ...state.kpiProgress, showModal: false },
      };
    case fetchKPIByIdV2.FAILURE:
      return {
        ...state,
        kpi: {
          ...state.kpi,
          loading: false,
          error: action.payload.error,
        },
      };

    // LOOKUP STUFF BELOW

    case fetchKPIProgressLookupsV2.TRIGGER: {
      return {
        ...state,
        [KPI_PROGRESS]: { ...state[KPI_PROGRESS], loading: true },
      };
    }
    case fetchKPIProgressLookupsV2.FAILURE: {
      return {
        ...state,
        [KPI_PROGRESS]: {
          ...state[KPI_PROGRESS],
          error: action.payload.error,
          loading: false,
        },
      };
    }
    case fetchKPIProgressLookupsV2.SUCCESS: {
      return {
        ...state,
        [KPI_PROGRESS]: {
          ...state[KPI_PROGRESS],
          data: action.payload,
          dataMap: responseFormatter(action.payload, 'lookupId'),
          loading: false,
          error: null,
        },
      };
    }

    case resetKPIsV2.TRIGGER: {
      return {
        ...state,
        kpiList: initialState.kpiList,
        kpi: initialState.kpi,
      };
    }

    default:
      return state;
  }
};

export default successPlanKPIReducerV2;
